Wee.fn.make('categoriesGrid', {
	init: function() {
		if ($('ref:solutionsContainer').length) {
			this.$private.initGridBlock();
		}
	}
}, {
	initGridBlock: function() {
		var $children = $('ref:solutionsContainer').children('ref:gridItem'),
			count = $children.length,
			gridClass = '-half-column';

		if (count % 3 == 2) {
			$($children[1]).addClass(gridClass);
			$children.first().addClass(gridClass);
		}
	}
});